
























































import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import {
  BiaggregateAisummaryPromptTemplate,
  DefaultBiaggregateAisummaryPromptTemplate,
} from "#/model/biaggregate";
import {
  LLM_TYPE,
  LLM_TYPES,
  BLOCK_TYPE,
  BLOCK_TYPES,
  BLOCK_TYPE_COLORS,
} from "@/views/biaggregate/const";
import { DefaultExperimentRes } from "@/components/ai/types";
import ExperimentResViewer from "@/components/ai/ExperimentResViewer.vue";

@Component({ components: { ExperimentResViewer } })
export default class extends Mixins(AxiosMixin, UtilMixin, RulesMixin) {
  /** お試し結果表示ダイアログ制御用 */
  @Ref("experimentResViewer")
  protected readonly experimentResViewer!: ExperimentResViewer;

  /** 集計AIサマリプロンプトテンプレート */
  @Prop({ default: () => DefaultBiaggregateAisummaryPromptTemplate() })
  private promptTemplate!: BiaggregateAisummaryPromptTemplate;

  /** LLM種類(定数) */
  private LLM_TYPE = LLM_TYPE;

  /** LLM種類(選択肢) */
  private LLM_TYPES = LLM_TYPES;

  /** ブロックタイプ(定数) */
  private BLOCK_TYPE = BLOCK_TYPE;

  /** ブロックタイプ(選択肢) */
  private BLOCK_TYPES = BLOCK_TYPES;

  /** ブロックタイプ(チップ色) */
  private BLOCK_TYPE_COLORS = BLOCK_TYPE_COLORS;

  /** お試し結果 */
  protected experimentRes = DefaultExperimentRes();

  /** お試し実行 */
  private experiment() {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/prompt/run",
      {
        prompt_template: this.promptTemplate,
      },
      async (res) => {
        this.experimentRes = res.data.run_res;
        this.experimentResViewer.open();
      }
    );
  }
}
